import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { HttpFunctionsService } from '../http-services/http-functions.service';
import { CommonService } from '../Common-function/common.service';
import { BehaviorSubject, Observable, throwError, forkJoin, of } from 'rxjs';
import { SubscriptionListModel } from 'src/app/models/subscription-list.model';
import { ActivatedSubsList, CurrentActivatedPlan } from 'src/app/models/activated-subscription.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { SubsModel } from 'src/app/models/subs.model';
import { SubscriptionModel } from 'src/app/models/subscription-model';
import Subscription_Data from '../../../assets/data/subs-data.json';
import { BrowserStorageService } from '../browser-storage/browser-storage.service';
import { CreditService } from '../credit/credit.service';
import { CreditQuotaHelper } from 'src/app/constants/credit-quota.constants';
import {
  PlanOverlay,
  buildCatalog,
  getPlanCredits,
  getSellablePlans,
  resolveActivePlan,
  withLegacyActivePlan
} from './subscription-plan.mapper';

// Interface for subscription with credits
export interface SubscriptionWithCredits {
  subscriptionTiers: string[];
  activeSubscriptions: Array<{
    planId: string;
    subscriptionId: string;
    frequency: 'monthly' | 'annual';
    invoices: any[];
    expiresOnCycleEnd: boolean;
    nextBillingDueAt: string;
    createdAt?: string;
    endAt?: string;
  }>;
  credits: {
    balance: number;
    quota: number;
  };
  sellerCommissionPercent?: number;
}

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {

  subscriptionUrl: string = 'subscription-plan/';
  producerSubscriptionUrl: string = 'producer-subscription/';
  subscriptionPlansApiUrl: string = "subscriptions";
  displayItemList: Array<any> =  [
    {
      labelName: 'Unlimited Uploads :',
      value: 'icon',
    },
    {
      labelName: 'Digital Licensing:',
      value: 'icon',
    },
    {
      labelName: 'Direct Bank Transfer :',
      value: 'icon',
    },
    {
      labelName: 'Keep {Percentage} Royalties :',
      value: 'icon',
    },
    {
      labelName: 'Previous Settings :',
      value: 'icon',
    },
    {
      labelName: 'Automated Pricing :',
      value: 'icon',
    }
  ];
  annualPlanPrice: any = [{
    plan: 'Pro Plan',
    amount: "",
    monthlyAmount: "",
    },
    {
      plan: 'Premium Plan',
      amount: "",
      monthlyAmount: "",
    }
  ];
  activeSubscription: BehaviorSubject<any> = new BehaviorSubject('');
  activeSubsPlanDetails: any = "";
  isIndiaWinsSaleOfferApplied: boolean = false;
  constructor(
    private httpCommonService: HttpFunctionsService,
    public commonService: CommonService,
    public ngxService: NgxSpinnerService,
    public browserService: BrowserStorageService,
    private creditService: CreditService) {
  }

  getSubscriptionList(): Observable<Array<SubscriptionListModel>> {
    return this.httpCommonService.getMethod(this.subscriptionUrl + `list`).pipe( map((subRes:any) => {
      let subsList: Array<SubscriptionListModel> = [];
      if (subRes.data &&  subRes.data.length > 0) {
        subsList = subRes.data.filter((item: any) => {
            item = this.createSubsData(item);
            return item;
        });
      }
      return subsList
    }),catchError(error => {
      return throwError(error)
    }));
  }

  /**
   * In this function getting active subscription
   * @returns 
   */
  getActivatedSubscriptionList(): Observable<ActivatedSubsList> {
    this.ngxService.show();
    return this.httpCommonService.getMethod(this.producerSubscriptionUrl + `list`).pipe( map( res => {
      let subsObj: any = {};
      if (res.data &&  res.data.length > 0) { 
        let activatedSubsList: any = res.data[0];
        activatedSubsList.subscription_plan = this.createSubsData(activatedSubsList.subscription_plan);
        subsObj = activatedSubsList;
      }
      return subsObj;
    }),catchError(error => {
      return throwError(error)
    }));
  }


  /**
   * Is this set heading and sub heading list
   * @param subsObj 
   * @returns 
   */
  createSubsData(subsObj: SubscriptionListModel) {
    subsObj.subs_displayList = JSON.parse(JSON.stringify(this.displayItemList));
    subsObj.isSelected = false;
    let label = subsObj.subs_displayList[subsObj.subs_displayList.length - 3].labelName;
    if (subsObj.slug === "free") {
      subsObj.subs_heading = "Freemium Marketplace";
      subsObj.order = -1;
      subsObj.isShowing = true;
      subsObj.subs_displayList[subsObj.subs_displayList.length - 1].value = "";
      subsObj.subs_displayList[subsObj.subs_displayList.length - 2].value = "";
      subsObj.subs_displayList[subsObj.subs_displayList.length - 3].labelName = label.replace('{Percentage}', "80%");
      subsObj.subs_displayList[subsObj.subs_displayList.length - 3].isShowIcon = true;
    } else {
      subsObj.subs_heading = "Premium Marketplace";
      subsObj.order = 1;
      subsObj.subs_displayList[subsObj.subs_displayList.length - 3].labelName = label.replace('{Percentage}', "100%");
    }
    subsObj.isShowing = true;
    return subsObj;
  }

  /**
* create Order
* @param subscriptionPlanId 
* @returns 
*/
  createOrder(subscriptionPlanId: any,addressId?:any) {
    let sendData:any = {
      "subscription_plan_id": subscriptionPlanId,
    }
    if(addressId){
      sendData["billing_address_id"]= addressId
    }
    return this.httpCommonService.postMethod(this.producerSubscriptionUrl + 'insert', sendData);
  }

  // cancel the active subscription
  cancelSubscription() {
    return this.httpCommonService.postMethod(this.producerSubscriptionUrl + 'cancel', {});
  }

  getSubsData(): Observable<SubsModel[]> {
    return this.httpCommonService.getDataFromAssets("../../../assets/data/subs-data.json").pipe( map((SubsRes: any) => {
      let subsList: Array<SubsModel> = []; 
      if (SubsRes) {
        SubsRes.filter( (subs:any) => subs['isShowPlan'] = true);
        subsList = SubsRes.reverse();
       }
       return  subsList;
    }), catchError( error => {
      return throwError(error);
    }));
  }

  /**
   * get All Subscription Plans
   * @returns 
   */
  getAllSubscriptionPlans(): Observable<SubscriptionModel[]> {
    return this.httpCommonService.getMethod(`${this.subscriptionPlansApiUrl}/plans`).pipe(map((subsResponse: any) => {
      return this.preparePlanData(subsResponse?.plans ?? []);
    }),catchError( (error: any) => {
      return throwError(error);
    }));
  }

  getCurrentSubscription() {
    return this.httpCommonService.getMethod(`${this.subscriptionPlansApiUrl}/mySubscriptions`);
  }

  /**
   * Get subscription data combined with credit balance
   * Fetches both APIs in parallel using forkJoin
   * @returns Observable of subscription with credits
   */
  getSubscriptionWithCredits(): Observable<SubscriptionWithCredits> {
    return forkJoin({
      subscription: this.getCurrentSubscription(),
      credits: this.creditService.getCreditBalance(),
      catalog: this.getPlanCatalog()
    }).pipe(
      map(({ subscription, credits, catalog }) => {
        // Extract the highest tier
        const tier = subscription.subscriptionTiers?.[subscription.subscriptionTiers.length - 1] || 'tier0';
        // Use the last (most recent) active subscription — after an upgrade, the new plan is appended
        const latestSub = subscription.activeSubscriptions?.[subscription.activeSubscriptions?.length - 1];
        const frequency = latestSub?.frequency || 'monthly';
        const isCommission = (subscription.sellerCommissionPercent || 0) > 0;

        // Quota from the active plan's creditsPerCycle; old plans (0) fall back to the constants table
        const activePlan = resolveActivePlan(catalog, subscription.activeSubscriptions)?.plan;
        const quota = getPlanCredits(activePlan, CreditQuotaHelper.getQuota(tier, frequency, isCommission));

        return {
          ...subscription,
          sellerCommissionPercent: subscription.sellerCommissionPercent,
          credits: {
            balance: credits,
            quota: quota
          }
        };
      }),
      catchError(error => {
        return throwError(error);
      })
    );
  }


  /**
   * The user is on the Pro Annual plan: highest tier is Pro (tier2) and the latest active subscription is billed
   * annually (same rule as getSubscriptionWithCredits). The Diwali "45% off on Pro Annual" offer is hidden for them.
   */
  isOnProAnnual(activePlan: CurrentActivatedPlan | '' = this.activeSubscription.value): boolean {
    if (!activePlan) {
      return false;
    }
    const tier = activePlan.subscriptionTiers?.[activePlan.subscriptionTiers.length - 1];
    const latestSubscription = activePlan.activeSubscriptions?.[activePlan.activeSubscriptions.length - 1];
    return tier === 'tier2' && latestSubscription?.frequency === 'annual';
  }

  /** Full plan catalog (old plans included). On error returns [] so callers use their fallbacks. */
  private getPlanCatalog(): Observable<SubscriptionModel[]> {
    return this.httpCommonService.getMethod(`${this.subscriptionPlansApiUrl}/plans`).pipe(
      map((res: any) => buildCatalog(res?.plans ?? [], this.planOverlays)),
      catchError(() => of([] as SubscriptionModel[]))
    );
  }

  private get planOverlays(): Array<PlanOverlay> {
    return Subscription_Data as Array<PlanOverlay>;
  }

  /**
   * Builds the pricing page list from the API plans:
   * - only sellable (new) plans are listed, see isSellablePlan()
   * - the user's current plan is looked up in ALL plans, so an old plan is still
   *   listed (flagged isLegacy) and can be managed / cancelled
   */
  preparePlanData(apiPlans: Array<SubscriptionModel>): Array<SubscriptionModel> {
    const catalog = buildCatalog(apiPlans, this.planOverlays);
    const activeResponse: CurrentActivatedPlan | '' = this.activeSubscription.value;
    const active = resolveActivePlan(catalog, activeResponse ? activeResponse.activeSubscriptions : []);
    this.activeSubsPlanDetails = active?.plan ?? '';

    const plans = withLegacyActivePlan(getSellablePlans(catalog, this.planOverlays), active).map(plan => this.applySaleFlags(plan));
    const hasNoCommissionPlans = plans.some(plan => !plan.isCommission);
    return [...this.getStaticPlans(hasNoCommissionPlans), ...plans]
      .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
      // every card (including the "Without Commission" heading) starts visible and unselected
      .map(plan => ({ ...plan, isShowPlan: true, isSelected: false }));
  }

  /** Basic (free) card and the "Without Commission" heading come from static data, not from the API. */
  private getStaticPlans(hasNoCommissionPlans: boolean): Array<SubscriptionModel> {
    const staticPlans: Array<SubscriptionModel> = [];
    this.planOverlays.forEach((subsPlan: any) => {
      const planName: string = subsPlan.plan_name.split(' ')[0];
      if (planName === 'Basic') {
        subsPlan.frequency.forEach((type: string) => {
          staticPlans.push({
            tier: 'tier0',
            planName: subsPlan.plan_name,
            price: 0,
            actualPrice: 0,
            offerText: '',
            isShowRoyaltyDetails: subsPlan.isShowRoyaltyDetails,
            royaltyDetails: subsPlan.royaltyDetails,
            razorpayPlanId: '',
            sellerCommissionPercent: 30,
            isActive: subsPlan.isActive,
            isShowButton: subsPlan.isShowButton,
            featuresList: JSON.parse(JSON.stringify(subsPlan.featuresList)),
            backgroundColor: subsPlan.backgroundColor,
            compareFeaturesList: JSON.parse(JSON.stringify(subsPlan.compareFeaturesList)),
            isShowBpmOfferSection: false,
            isShowRecommendOption: subsPlan.isShowRecommendOption,
            isCommission: subsPlan.isCommission,
            order: subsPlan.order,
            id: subsPlan.id,
            isExpandPlan: false,
            className: subsPlan.className,
            frequency: type,
            isSelected: false,
            isShowPlan: true
          });
        });
      } else if (planName === 'Without' && hasNoCommissionPlans) {
        staticPlans.push({
          tier: 'label',
          order: subsPlan.order,
          planName: subsPlan.plan_name,
          id: subsPlan.id,
          isCommission: subsPlan.isCommission,
          frequency: ''
        });
      }
    });
    return staticPlans;
  }

  /** Sale / offer flags that depend on session state, not on the plan itself. */
  private applySaleFlags(plan: SubscriptionModel): SubscriptionModel {
    const saleActive = this.browserService.getSaleActiveFlag();
    // "Recommended" stays on during a sale: the Diwali Pro card carries its own orange "Recommended" tab
    const flagged: SubscriptionModel = {
      ...plan,
      isShowBpmOfferSection: saleActive
    };
    if (this.isIndiaWinsSaleOfferApplied && !plan.isCommission && plan.frequency === 'annual') {
      flagged.isIndiaWinsSaleOfferApplied = true;
      flagged.bpmAcutalPriceAmmount = plan.price;
      if (plan.tier === 'tier2') {
        flagged.price = 5999;
      } else if (plan.tier === 'tier1') {
        flagged.price = 3999;
      }
    }
    return flagged;
  }

  /**
   * create subscription
   * @param data 
   */
  createSubscription(data: any) {
    return this.httpCommonService.postMethod(`${this.subscriptionPlansApiUrl}/createSubscription`, data);
  }

  cancelSubscriptionEvent(subscriptionId: string) {
    let data = {
      "subscriptionId": subscriptionId
    }
    return  this.httpCommonService.postMethod(`${this.subscriptionPlansApiUrl}/cancelSubscription`, data);
  }

  /**
   * Coupon Validation
   */
  couponValidation(planId: any, couponCode: string) {
    let data = {
      "planId": planId,
      "offerCode": couponCode
    }
    return this.httpCommonService.postMethod(`${this.subscriptionPlansApiUrl}/isOfferValid`, data);
  }
}
